import store from "@/store";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { Component, Vue } from "vue-property-decorator";

const ZOOM_STEP = 0.1;
const ZOOM_MIN = 0.8;
const ZOOM_MAX = 1.4;

@Component
export default class AppHeader extends Vue {
  cleanInrsLink = sanitizeUrl(this.$t("components.pageHeader.inrs.link.href").toString());
  zoom = 1;

  /**
   *  We get the title from studio. In case of null or empty variable in store we get it from the json file
   */
  get title(): string {
    return (
      store.state.globalAppDataModule.title ||
      this.$t("components.pageHeader.fallback.title").toString()
    );
  }

  get inrsLogoUrl(): string {
    const contextPath: string = Vue.prototype.URL_ContextPath || "";
    return contextPath + "/.resources/templating-kit/themes/inrs/img/HEADER.svg";
  }

  get mailtoLink(): string {
    const subject = encodeURIComponent(this.title);
    const body = encodeURIComponent(
      this.$t("components.pageHeader.toolbar.mailBody", {
        title: this.title,
        url: window.location.href,
      }).toString()
    );
    return "mailto:?subject=" + subject + "&body=" + body;
  }

  print(): void {
    window.print();
  }

  changeFontSize(increment: number): void {
    const next = increment === 0 ? 1 : this.zoom + increment * ZOOM_STEP;
    this.zoom = Math.round(Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, next)) * 10) / 10;
    document.documentElement.style.setProperty("--abaca-zoom", this.zoom.toString());
  }
}
